module.exports = __webpack_public_path__ + "media/components/common/formParts/img/dummy-footer-5d5d727625c04ef640d9cab18677d019.png";